module.exports = __webpack_public_path__ + "img/map_Z5.2.C.06.8860e49d.svg";